(function($){
	$(document).ready(function() {
	
		// console.log('cur-product-vaultdoors-specs.js loaded!');

		$('.cur-product-vaultdoors-specs .specs-tabs .tabs-container .tab').on('click', function(event) {
			if (!$(this).hasClass('active')) {
				var $tabs = $('.cur-product-vaultdoors-specs .specs-tabs .tabs-container .tab');
				$tabs.removeClass('active').attr('aria-selected', 'false').attr('tabindex', '-1');
				$(this).addClass('active').attr('aria-selected', 'true').attr('tabindex', '0');
				$('.cur-product-vaultdoors-specs .specs-container').hide();
				$('.cur-product-vaultdoors-specs .specs-container.' + $(this).data('tab')).show();
			}
		});

	});
})(jQuery);
